var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("section", { staticClass: "help-container" }, [
    _c("div", { staticClass: "help-title" }, [
      _c("span", { staticClass: "help-text" }, [
        _vm._v(_vm._s(_setup.text.help)),
      ]),
    ]),
    _c("div", { staticClass: "help-info" }, [
      _c("div", { staticClass: "phones-container" }, [
        _c("span", { staticClass: "phone" }, [
          _vm._v(_vm._s(_setup.text.phone1)),
        ]),
        _c("span", [_vm._v("-")]),
        _c("span", { staticClass: "phone" }, [
          _vm._v(_vm._s(_setup.text.phone2)),
        ]),
      ]),
      _vm._m(0),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", [
      _c("span", [
        _c(
          "a",
          {
            staticClass: "email",
            attrs: { href: "mailto:clientes@lefebvre.es" },
          },
          [_vm._v("clientes@lefebvre.es")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }